import React from 'react'
import HTag from '@/lib/HTag'
import Img from '@/lib/Img'

const LogoGrid = ({ heading, logos }) => (
	<section className="section">
		<HTag className="h2 text-center" {...heading} />

		<ul className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-8 md:gap-x-12 mt-8">
			{logos?.map((logo, key) => (
				<li key={key}>
					<figure className="max-w-[200px] m-auto">
						<Img {...logo} />
					</figure>
				</li>
			))}
		</ul>
	</section>
)

export default LogoGrid
